export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8660.4da88caf.jpg";